import React from 'react';

export type StatusTone = 'neutral' | 'brand' | 'info' | 'warning' | 'success' | 'danger';

const DOT_CLASSES: Record<StatusTone, string> = {
    neutral: 'bg-foreground-muted',
    brand: 'bg-orange-500',
    info: 'bg-info',
    warning: 'bg-warning',
    success: 'bg-success',
    danger: 'bg-danger',
};

export default function StatusBadge({
    label,
    tone = 'neutral',
}: {
    label: string;
    tone?: StatusTone;
}) {
    return (
        <span className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-foreground">
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${DOT_CLASSES[tone]}`} />
            {label}
        </span>
    );
}
